module.exports = __webpack_public_path__ + "img/typewriter-story.ffd4a19.jpg";